import React, { Component } from 'react';
import CanvasDraw from "react-canvas-draw";
import {
    Button, FormGroup, ComposedModal, ModalHeader, ModalBody, ModalFooter, TextArea, Loading
} from 'carbon-components-react';
import { fileUpload, api } from '../../helpers/api/api';
import { v4 as uuid } from 'uuid';
import { ComboBox } from '../../helpers/ComboBox'
import { Erase16 } from '@carbon/icons-react';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { entitiesLabels } from '../../helpers/Constants';
import ImgSignature from './ImgSignature'

export default class ModalSignatureTrainer extends Component { //RITM0984969
    constructor(props) {
        super(props);
        this.state = {
            model: {
                ...this.props.editModel
            },

            StoragePath: 'training',
            isSubmitted: false,
            showCanvas: this.props.editModel && !this.props.editModel.signatureAttachment
        }
    }

    componentDidMount() {
    }




    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state.model);
        if (objName && objName != 'model') statusCopy[objName][inputName] = inputValue;
        else statusCopy[inputName] = inputValue;

        this.setState({ model: statusCopy, });
    }

    clearImage = () => {
        if (this.props.editModel && this.props.editModel.signatureAttachment) {
            
            this.setState({
                showCanvas: true
            });

        }
        if (this.saveableCanvas) this.saveableCanvas.clear();
    }

    showLoading() {
        return (this.state.isSubmitted && <Loading active={true} withOverlay={true} description={"Saving..."} />);
    }

    save = async () => {
        this.setState({ 'isSubmitted': true });
        let dati = this.state.model;

        try {
            let fileIdentifier = await this.saveImage();

            if (fileIdentifier != null) dati.signatureAttachment = fileIdentifier
            if (!dati.signatureAttachment && this.props.editModel.signatureAttachment) dati.signatureAttachment = this.props.editModel.signatureAttachment

            await api.put('/training/', dati, `${this.props.idTraining}/signatureTrainer/${this.props.editModel.id}`);

            this.props.save(dati);
            showNotification.success(`${entitiesLabels.SUCCESS}`, "Trainer saved successfully");
        } catch (error) {
            showNotification.error(`${entitiesLabels.ERROR}`, "Error saving Trainer: " + error.message);
        } finally {
            this.setState({ 'isSubmitted': false });
        }
    }

    saveImage = async () => {
       
        try {
            if (this.saveableCanvas) {
                const canvas = this.saveableCanvas.canvasContainer.children[1];
                if (canvas == null || isCanvasBlank(canvas)) {
                   
                    return null;
                }
                this.setState({ 'isSubmitted': true });
                const csvURL = canvas.toDataURL();
                const base64 = csvURL.split(',')[1];
                const fileAsBlob = base64toBlob(base64, 'image/png');

                const fileName = `sg${uuid()}.png`;

                const blobAsFile = new File([fileAsBlob], fileName, {
                    type: 'image/png',
                });

                const fileIdentifier = `${this.state.StoragePath}_${new Date().getTime()}_${fileName}`;

                const formData = new FormData();
                formData.append('File', blobAsFile);
                formData.append('Container', 'saipem');
                formData.append('StoragePath', this.state.StoragePath);
                formData.append('FileIdentifier', fileIdentifier);

                await fileUpload.post(formData);
                return fileIdentifier;
            }
        }
        catch (error) {
            throw error;
        }
        
        return null;
    }

    render() {
        if (this.props.editModel == null) return null;

        const { title, isOpenModal } = this.props;

        const showCanvas = this.state.showCanvas;
        const thereIsImage = this.state.model && this.state.model.signatureAttachment
        const modalHeader = {
            title: title || 'Signature',
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        return (
            <ComposedModal
                className="light-modal"
                open={isOpenModal}
                danger="false"
                onClose={() => { return false; }}
            >
                <ModalHeader className="margin-modal" {...modalHeader} ></ModalHeader>
                <ModalBody className="margin-modal">
                    {this.showLoading()}
                    <div className="bx--grid--full-width">

                        <div className="bx--row row-content canvas-sign">
                            {(showCanvas || thereIsImage) &&
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <h3>{`${this.props.editModel.name} ${this.props.editModel.surname}`}</h3>
                                </div>
                            }
                            {showCanvas ?
                                <div className="bx--col-lg-12 bx--col-md-12">
                                    <CanvasDraw
                                        ref={canvasDraw => (this.saveableCanvas = canvasDraw)}
                                        onChange={null}
                                        loadTimeOffset={0}
                                        lazyRadius={2}
                                        brushRadius={2}
                                        brushColor="#444"
                                        catenaryColor="#0a0302"
                                        gridColor="rgba(150,150,150,0.17)"
                                        hideGrid={false}
                                        canvasWidth={473}
                                        canvasHeight={200}
                                        disabled={false}
                                        imgSrc=""
                                        saveData={null}
                                        immediateLoading={false}
                                        hideInterface={true}
                                    />
                                    <Button kind='danger' size='field' renderIcon={Erase16} onClick={() => this.clearImage()}>Clear</Button>
                                </div>
                                : thereIsImage ?
                                    <div className="bx--col-lg-12 bx--col-md-12">
                                        <div>
                                            <ImgSignature idTraining={this.props.idTraining} fileIdentifier={this.props.editModel.signatureAttachment} />
                                        </div>
                                        <Button kind='danger' size='field' renderIcon={Erase16} onClick={() => this.clearImage()}>Clear</Button>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                    <Button kind='primary' onClick={() => this.save()} >Save</Button>
                </ModalFooter>
            </ComposedModal>
        );
    }
}


function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    const sliceSize = 1024;
    const byteCharacters = window.atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);

    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);

        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

function isCanvasBlank(canvas) {
    return !canvas.getContext('2d')
        .getImageData(0, 0, canvas.width, canvas.height).data
        .some(channel => channel !== 0);
}